import { render, staticRenderFns } from "./InkassDateCard.vue?vue&type=template&id=50d74370&scoped=true&"
import script from "./InkassDateCard.vue?vue&type=script&lang=js&"
export * from "./InkassDateCard.vue?vue&type=script&lang=js&"
import style0 from "./InkassDateCard.vue?vue&type=style&index=0&id=50d74370&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d74370",
  null
  
)

export default component.exports